import React, { useEffect, useState } from 'react';
import "./NewCollections.css";
import Item from '../Items/Item';

const NewCollections = () => {
  const [newCollection, setNewCollection] = useState([]);
  const [limit, setLimit] = useState(4); // default 4 products
  const API_BASE = process.env.REACT_APP_API_BASE_URL; // .env

  useEffect(() => {
    const fetchNewCollections = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/products/newcollections`);
        if (!response.ok) {
          console.error("Error fetching new collections:", response.status);
          return;
        }
        const data = await response.json();
        setNewCollection(data);
      } catch (err) {
        console.error("Server error fetching new collections:", err);
      }
    };
    fetchNewCollections();
  }, [API_BASE]);

  return (
    <div id="allproduct" className='new-collection'>
      
      {/* HEADER */}
      <div className="newcollection-header">
        <h1>Our All Products</h1>

        {/* FILTER */}
        <select
          className="collection-filter"
          value={limit}
          onChange={(e) => setLimit(Number(e.target.value))}
        >
          <option value={4}>Show 4</option>
          <option value={5}>Show 5</option>
          <option value={6}>Show 6</option>
          <option value={0}>Show All</option>
        </select>
      </div>

      <hr />

      {/* PRODUCTS */}
      <div className='collection'>
        {(limit === 0 ? newCollection : newCollection.slice(0, limit))
          .map((item, i) => (
            <Item
              key={i}
              id={item.id}
              name={item.name}
              image={item.image}
              new_price={item.new_price}
              old_price={item.old_price}
            />
          ))}
        {newCollection.length === 0 && <p>No products found.</p>}
      </div>
    </div>
  )
}

export default NewCollections;
